import { render } from "./AccordionItem.vue?vue&type=template&id=c0a869f0&scoped=true&ts=true"
import script from "./AccordionItem.vue?vue&type=script&lang=ts"
export * from "./AccordionItem.vue?vue&type=script&lang=ts"

import "./AccordionItem.vue?vue&type=style&index=0&id=c0a869f0&scoped=true&lang=css"
import "./AccordionItem.vue?vue&type=style&index=1&id=c0a869f0&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0a869f0"]])

export default __exports__